// Generated by ReScript, PLEASE EDIT WITH CARE


var array = [
  /* Home */7,
  /* About */0,
  /* Publications */1,
  /* Projects */2,
  /* Education */3,
  /* WorkExperience */4,
  /* Reading */5
];

function fromString(string) {
  switch (string) {
    case "About / Contact" :
        return /* About */0;
    case "Currently Reading" :
        return /* Reading */5;
    case "Education" :
        return /* Education */3;
    case "" :
    case "Home" :
        return /* Home */7;
    case "Projects" :
        return /* Projects */2;
    case "Publications" :
        return /* Publications */1;
    case "Work Experience" :
        return /* WorkExperience */4;
    default:
      return /* Invalid */6;
  }
}

function toString(route) {
  switch (route) {
    case /* About */0 :
        return "About / Contact";
    case /* Publications */1 :
        return "Publications";
    case /* Projects */2 :
        return "Projects";
    case /* Education */3 :
        return "Education";
    case /* WorkExperience */4 :
        return "Work Experience";
    case /* Reading */5 :
        return "Currently Reading";
    case /* Invalid */6 :
        return "Invalid";
    case /* Home */7 :
        return "Home";
    
  }
}

export {
  array ,
  fromString ,
  toString ,
}
/* No side effect */
